<template>
    <v-card class="my-0" v-if="trip">
        <v-card-title class="title card-title-head">
        {{ $i18n.t("Client Cargos") }}
        <v-spacer />
        
        <v-btn
            x-small
            fab
            text
            color="light-blue"
            class="float-right"
            @click="addNewEmptyCargo"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        </v-card-title>
          <v-card-text
            class="py-0"
            v-if="trip && trip.clientCargos && trip.clientCargos.length > 0"
          >
            <v-simple-table v-if="trip">
                <v-card
                    class="my-3"
                    v-for="(cargo, index) in trip.clientCargos"
                    :key="index"
                >
                    <client-cargo :clientCargoItem="cargo" 
                        :indexItem="index" 
                        :trip="trip"
                        @reload="closeDialog"
                        :errors="errors"
                        @reloadError="reloadError"
                    />
                </v-card>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import ClientCargo from "@/views/trip/ClientCargo.vue";

@Component({
  name: "Cargos",
  props: {
    value: {
      default: null,
    },
    errors: {
      default: {}
    }
  },
  components: {
    ClientCargo,
  },
})
export default class Cargos extends Vue {
    trip = null;

    closeDialog(reload) {
        this.$emit("reload", reload);
    }

    addNewEmptyCargo() {
      const cargo = {
          material: null,
          src: { country: "India", state: null, city: null, addressLine: null },
          dst: { country: "India", state: null, city: null, addressLine: null },
          consignor: {},
          consignee: {},
          invBranch: { address: {} },
          loadAsst: [],
          unloadAsst: [],
          lr: {number: null, wayBillNo: null,
            date: null, invoiceNo: null,
            insurance: { currency: "INR", amount: null } 
          },
      };

      const charge = {
        taxItem: {},
        discounts: [],
        items: [
          {
            name: null,
            desc: null,
            units: 1,
            unitCost: null,
            amount: null,
          },
        ],
      };

      charge.items[0].name = "Freight Charge";
      const fare = {charges:[]};
      fare.charges.push(charge);

      const clientCargo = {
          client_id : null,
          clientEntity_id : null,
          billing : {fare:fare},
          cargos : []
      }
        clientCargo.cargos.push(cargo);
        if (!this.trip.clientCargos) this.trip.clientCargos = [];
        this.trip.clientCargos.push(clientCargo);
    }    

    mounted() {
        this.trip = this.value;
    }

    @Watch("value")
    async onValueChange(val) {
        this.trip = val;
    }

    reloadError(reload, val) {
      this.$emit("reloadError", reload, val);
    }
}
</script>

<style scoped>
.v-text-field__details {
  display: none;
}
.v-input input[type="number"] {
  text-align: right !important;
}

.dense tr td {
  padding: 0 3px !important;
}
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>